// extracted by mini-css-extract-plugin
export default {"col_banner":"style_col_banner_9hsbv"};